import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Expand } from "lucide-react";
import Plot from "react-plotly.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "80%",
  bgcolor: "background.paper",
  //   border: '2px solid #000',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
};

export default function BasicModal({ chartData, plot }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <span style={{ display: "grid", justifyContent: "flex-end" }}>
        <Button
          onClick={handleOpen}
          sx={{
            display: "grid",
            justifyContent: "flex-end",
            width: "100%",
            right: "10px",
            cursor: "pointer",
            background: "transparent",
          }}
        >
          <Expand />
        </Button>
      </span>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" component="h2">
            {plot.title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {plot.description}
          </Typography>

          <Plot
            data={chartData}
            layout={{
              ...plot.layout,
              // margin: { l: 80, r: 40, t: 40, b: 120 },
              autosize: true,
              responsive: true,
              showlegend: true,
              legend: {
                orientation: "h", // horizontal
                x: 0.5, // center horizontally
                xanchor: "center", // anchor at center
                y: -0.5, // move below chart
                yanchor: "top", // align to top of legend box
              },
              plot_bgcolor: "rgba(0,0,0,0)",
              paper_bgcolor: "rgba(0,0,0,0)",
              font: { family: "Arial, sans-serif" },
              title: { font: { size: 16, family: "Arial, sans-serif" } },
              // colorway: [
              //   "#bb1ccc",
              //   "#a89e32",
              //   "#32a852",
              //   "#6d32a8",
              //   "#009966",
              //   "#cc0000",
              // ], // global color palette
              colorway: ["#005aff", "#009966", "#0000a0", "#6d32a8", "#bb1ccc", "#cc0000"],

              xaxis: {
                title: {
                  text: plot.layout?.xaxis?.title || "X Axis",   // fallback if not set
                  font: { size: 12, family: "Arial, sans-serif" },
                  standoff: 10,   // 👈 adds spacing between axis & title

                },
                tickangle: -45,
                tickfont: { size: 10 },
                automargin: true,
              },
              yaxis: {
                title: {
                    text: plot.layout?.yaxis?.title || "Y Axis",   // fallback if not set

                  font: { size: 12, family: "Arial, sans-serif" },
                },
                tickfont: { size: 10 },
              },
            }}
            useResizeHandler={true}
            style={{ width: "100%", maxHeight: "100%", minHeight: "100%" }}
            config={{
              displaylogo: false,
              modeBarButtonsToRemove: [
                "lasso2d",
                "select2d",
                "hoverClosestCartesian",
                "hoverCompareCartesian",
                "toggleSpikelines",
              ],
              responsive: true,
            }}
          />
        </Box>
      </Modal>
    </div>
  );
}
